import { ActivatedRoute, Router } from '@angular/router';
import { AppsService, SnackBarService } from 'app/services';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { AddRoleDialogComponent } from '../add-role-dialog/add-role-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { RemoveRoleDialogComponent } from '../remove-role-dialog/remove-role-dialog.component';
import { Subject } from 'rxjs';
import { SnackbarType } from 'app/constants/Enums';
import { takeUntil } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import { TranslateService } from '@ngx-translate/core';


@Component({
  standalone: false,
  selector: 'app-apps-roles',
  templateUrl: './apps-roles.component.html',
  styleUrls: ['./apps-roles.component.scss']
})
export class AppsRolesComponent implements OnInit, OnDestroy {
  public roles: any[];
  public clientId: string;
  public rolesList: any[];
  private onDestroy$ = new Subject<void>();
  @Input() rolesSub: Subject<any[]>;
  currentPageRoles: any[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  rolesDataSource =  new MatTableDataSource([]);
  selection = new SelectionModel<any>(true, []);
  displayedColumns = [
    'roleId',
    'role'
  ];

  constructor(
    public dialog: MatDialog,
    private readonly route: ActivatedRoute,
    public readonly _appsService: AppsService,
    private readonly _snackbarService: SnackBarService,
    private readonly _router: Router,
    private readonly _translateService: TranslateService
  ) {}

  ngOnInit() {
    this.clientId = this.route.snapshot.params['client_id'];

    this.rolesSub.pipe(takeUntil(this.onDestroy$)).subscribe(roles => {
      this.roles = roles;
      this.rolesList = roles;
      this.rolesDataSource.data = this.roles;
      this.rolesDataSource.paginator = this.paginator;
      this.rolesDataSource
          .connect()
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((rolesList) => {
            this.currentPageRoles = rolesList;
          });
    });
  }
  ngOnDestroy() {
    this.onDestroy$.next(null);
  }

  goToRoles() {
    const dialogRef = this.dialog.open(AddRoleDialogComponent, {
      disableClose: true,
      autoFocus: false,
      panelClass: 'no-padding-dialog',
      width: '28vw',
      height: 'auto'
    });
    dialogRef.afterClosed().subscribe(() => {
      this._appsService.loading = false;
    });
  }

  changeCheckbox(item){
    if(!this.selection.isSelected(item)){
      this.selection.clear();
      this.selection.select(item);
    }
    else{
      this.selection.clear();
    }
  }

  goToDeleteRoles() {
    let title = '';
    let subTitle = '';
    const roleLength = this.selection.selected ? this.selection.selected.length : 0;
    if (roleLength === 0) {
      this._translateService
          .get('SNACKBAR.remove_roles')
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(value => (title = value));
        this._translateService
          .get('SNACKBAR.no_roles_selected')
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(value => (subTitle = value));
      this._snackbarService.showSnackbar(
        SnackbarType.info,
        title,
        subTitle
      );
    } else if (this.selection.selected[0].role === 'AppManager') {
      this._translateService
          .get('SNACKBAR.remove_roles')
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(value => (title = value));
      this._translateService
        .get('SNACKBAR.remove_app_mannger')
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(value => (subTitle = value));
      this._snackbarService.showSnackbar(
        SnackbarType.warning,
        title,
        subTitle
      );
    } else {
      const dialogRef = this.dialog.open(RemoveRoleDialogComponent, {
        disableClose: true,
        autoFocus: false,
        width: '35vw',
        panelClass: 'no-padding-dialog',
        height: 'auto',
        data: {
          roles: this.selection.selected
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this._appsService.loading = true;
          this._appsService
            .deleteRoles(this.clientId, this.selection.selected[0].roleId)
            .subscribe(() => {
              this._translateService
                .get('SNACKBAR.success')
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(value => (title = value));
              this._translateService
                .get('SNACKBAR.remove_success')
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(value => (subTitle = value));
              this._snackbarService.showSnackbar(
                SnackbarType.success,
                title,
                subTitle
              );
              this.selection.clear();
              this._appsService.getRoles(this.clientId);
              this._appsService.loading = false;
            });
        }
      });
    }
  }

  refreshAppName() {
    this._appsService.createApps(this.clientId)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(() => {
        this._appsService.getApps();
        this._router.navigate(['apps', this.clientId]);
      });
  }
}
